import { GetArticlesQuery, GetPageByRouteQuery } from "@eurodrive/apollo"
import { extractProperty, getBreadCrumbs } from "@eurodrive/utils"

import Banner from "@eurodrive/ui/Banner"
import ArticlesGrid from "./ArticlesGrid"
import ContentBox from "./ContentBox"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  articles: GetArticlesQuery
}

export default function ArticlesLobby({ data, locale, articles }: Props) {
  const heroBanner = extractProperty(data.page, "heroBannerInnerPages")?.[0]
  const topContent = extractProperty(data.page, "topContent")?.[0]
  const breadCrumbs = getBreadCrumbs(data, locale)
  return (
    <>
      <Banner data={heroBanner} compact={true} breadCrumbs={breadCrumbs} />
      <ContentBox data={topContent} />
      <ArticlesGrid articles={articles} />
    </>
  )
}
